import { Grid, SxProps, Theme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { stringifyValue } from "../utilities/stringHelper";

export interface TabPanelProps<T> {
  children?: React.ReactNode;
  selectedTab: T;
  value: T;
  sx?: SxProps<Theme>;
}

export function PersistedTabPanel<T>(props: TabPanelProps<T>) {
  const { children, value, selectedTab, sx, ...other } = props;
  const [rendered, setRendered] = useState(false);

  useEffect(() => {
    if (value === selectedTab) {
      setRendered(true);
    }
  }, [value, selectedTab]);

  if (!rendered) {
    return null;
  }

  return (
    <Grid
      container
      display={value === selectedTab ? "flex" : "none"}
      id={`dd-tabpanel-${stringifyValue(value)}`}
      width="100%"
      sx={sx}
      {...other}
    >
      {children}
    </Grid>
  );
}
